import React, { useState } from "react";
import Modal from "../components/Modal";
import { messageFeedback } from "../api/messageApi";
import { FiThumbsUp, FiThumbsDown } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

const Feedback = ({ onCloseClick, msgId, reaction }) => {
  const [feedback, setFeedback] = useState("");
  const submitClickHandler = async () => {
    await messageFeedback(msgId, feedback);
    onCloseClick();
  };
  return (
    <Modal>
      <div
        role="dialog"
        open
        className="relative col-auto col-start-2 row-auto row-start-2 w-5/6 rounded-xl text-left shadow-xl transition-all left-1/2 -translate-x-1/2 bg-white md:max-w-[672px] lg:max-w-[896px] xl:max-w-6xl"
        style={{ "pointer-events": "auto" }}
      >
        <div className="px-4 pb-4 pt-5 flex items-center justify-between border-b border-black/20">
          <div className="flex">
            <div className="flex items-center">
              {reaction ? (
                <div className="mr-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:h-10 sm:w-10 bg-green-100">
                  <FiThumbsUp color="green" />
                </div>
              ) : (
                <div className="mr-4 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full sm:h-10 sm:w-10 bg-red-100">
                  <FiThumbsDown color="red" />
                </div>
              )}
              <div className="flex grow flex-col gap-1">
                <h2
                  as="h3"
                  className="text-lg font-medium leading-6 text-gray-900 dark:text-gray-200"
                >
                  Provide additional feedback
                </h2>
              </div>
            </div>
          </div>
          <button
            className="text-gray-500 transition hover:text-gray-700 tex "
            onClick={onCloseClick}
          >
            <IoClose size={25} />
          </button>
        </div>
        <div className="p-4 sm:p-6">
          <form>
            <textarea
              id="feedback-other"
              placeholder="What do you like about the response?"
              rows="3"
              className="mb-1 mt-4 w-full resize-none rounded-md border border-black text-black p-1"
              style={{ height: "90px", "overflow-y": "hidden" }}
              onChange={(e) => {
                setFeedback(e.target.value);
              }}
            ></textarea>
          </form>
          <div className="mt-5 flex flex-col gap-3 sm:mt-4 sm:flex-row-reverse">
            <div className="flex items-center gap-3">
              <button
                className=" relative text-black border border-slate-400 px-2 rounded-md hover:border-black"
                as="button"
                onClick={submitClickHandler}
              >
                <div className="flex w-full gap-2 items-center justify-center">
                  Submit feedback
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
